import { Box, Typography } from '@mui/material';
import { Text } from '../../elements/text';
import { CustomisationProps, inputType } from './types';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useWatch } from 'react-hook-form';
import {
  CUSTOMISATION_STYLES,
  REQUIRED_TEXT,
} from '../../constants/styling/font';

export function Customisation(props: CustomisationProps) {
  const { customisation, itemCount, error, helperText } = props;
  const { options, name, _id, maximumSelections, minimumSelections } =
    customisation;
  const selectType = customisation.type;
  const Input = inputType[selectType];
  const isRequired =
    selectType === 'singleSelect' || selectType === 'mandatory';

  const fieldValue = useWatch({ name: _id });

  const isFieldIncomplete = (() => {
    if (selectType === 'singleSelect') {
      return !fieldValue || fieldValue === '';
    } else if (selectType === 'mandatory') {
      const selectedOptionsCount = Array.isArray(fieldValue)
        ? fieldValue.length
        : 0;
      return selectedOptionsCount < (minimumSelections || 0);
    }
    return false;
  })();
  const isFieldComplete = isRequired && !isFieldIncomplete;
  const shouldShowError = isRequired && error && isFieldIncomplete;
  const borderColor = shouldShowError
    ? CUSTOMISATION_STYLES.ERROR_BORDER
    : isFieldComplete
    ? CUSTOMISATION_STYLES.SUCCESS_BORDER
    : CUSTOMISATION_STYLES.DEFAULT_BORDER;

  const badgeBackgroundColor = shouldShowError
    ? CUSTOMISATION_STYLES.ERROR_BG
    : isFieldComplete
    ? CUSTOMISATION_STYLES.SUCCESS_BG
    : CUSTOMISATION_STYLES.DEFAULT_BG;

  const badgeBorderColor = shouldShowError
    ? CUSTOMISATION_STYLES.ERROR_BORDER
    : isFieldComplete
    ? CUSTOMISATION_STYLES.DEFAULT_BORDER
    : CUSTOMISATION_STYLES.DEFAULT_BORDER;

  return (
    <Box
      mt={2}
      mb={2}
      style={{
        border: `${borderColor}`,
        borderRadius: '9px',
        padding: '12px',
        backgroundColor: '#fff',
      }}
    >
      <Box
        display="flex"
        justifyContent={'space-between'}
        alignItems={'center'}
        mb={1}
      >
        <Box>
          <Typography variant="customisationOptionName">{name}</Typography>
        </Box>
        {isRequired && (
          <Box
            display="flex"
            alignItems="center"
            gap={0.5}
            style={{
              border: `1px solid ${badgeBorderColor}`,
              borderRadius: '6px',
              padding: '2px 6px',
              backgroundColor: badgeBackgroundColor,
            }}
          >
            {shouldShowError && (
              <WarningAmberIcon sx={{ fontSize: 16, color: '#000' }} />
            )}
            {isFieldComplete && (
              <CheckCircleIcon sx={{ fontSize: 16, color: '#22c55e' }} />
            )}
            <Typography variant="requiredText">{REQUIRED_TEXT}</Typography>
          </Box>
        )}
      </Box>
      <Input
        name={_id}
        options={options}
        itemCount={itemCount}
        error={error}
        helperText={helperText}
        minimumSelections={minimumSelections}
        maximumSelections={maximumSelections}
        type={selectType}
      />
    </Box>
  );
}
